// @flow

import { type PaymentSpec } from '@tectonics/prs/payment-spec';
import { type Feature } from '@tectonics/prs/feature';
import { type PaymentMethodCode } from '@tectonics/prs/payment-method';

export function getCurrentFeatures(spec: PaymentSpec, selectedPaymentMethodCode: PaymentMethodCode): ImmutableArray<Feature> {
  const paymentMethod = spec.paymentMethods.find((it)=>it.code === selectedPaymentMethodCode);
  return [
    ...spec.features,
    ...(paymentMethod ? paymentMethod.features : []),
  ];
}
